import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonCol, IonRow, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonGrid, useIonViewDidEnter } from '@ionic/react';
import { useParams } from 'react-router';
import ExploreContainer from '../components/ExploreContainer';
import { Descriptions, Row, Col, notification, message, Table, Tag, Modal } from 'antd';
import { Card } from 'antd';
import { Switch } from 'antd';
import { Input } from 'antd';
import moment from 'moment';
import { PageHeader } from 'antd';
import './Page2.css';
import { DatePicker, Space, Button } from 'antd';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { makeStyles } from "@mui/material/styles";
import { DataGrid, GridCellParams, GridSortDirection, GridToolbar } from '@mui/x-data-grid';
import { Backdrop, CircularProgress, MenuItem, Select } from '@mui/material';

const Equipment: React.FC = (props: any) => {
    const useStyles = makeStyles((theme) => ({
        backdrop: {
            background: "black",
            zIndex: theme.zIndex.drawer + 1,
            color: "#fff",
        },
    })
  );
    const [isModalCreateVisible, setIsModalCreateVisible] = useState(false);
    const [isModalCreateVisibleTable, setIsModalCreateVisibleTable] = useState(false);

    const showModalCreate = () => {
        setIsModalCreateVisible(true);
    };
    const showModalTable = () => {
        setIsModalCreateVisibleTable(true);
    };
    
    const handleCreateOk = () => {
        setIsModalCreateVisible(false);
    };
    const handleTableCreateOk = () => {
        setIsModalCreateVisibleTable(false);
        UpdateEquipment();
    };

    const handleCreateCancel = () => {
        setIsModalCreateVisible(false);
    };

    const { name } = useParams<{ name: string; }>();

    const columns = [

        { field: 'id', headerName: 'ID', width: 500 },
        { field: 'Name', headerName: 'NAME', width: 500 },
        {
            field: 'Status', headerName: 'STATUS', width: 500,
            renderCell: (params: GridCellParams) => (<strong>


                <Select               
                    id="status-select"
                    style={{ width: "180px" }}
                    onChange={(e) => statusChangeHandlerTable(e, params.row)}
                    value={params.value}

                >
                    <MenuItem value={"Enabled"}>Enabled</MenuItem>
                    <MenuItem value={"Disabled"}>Disabled</MenuItem>
                </Select>
            </strong>),
        }


    ];

    const [data1, SetData] = useState([]);

    const [enteredStatusTable, setEnteredStatusTable] = useState('');
    const [currentEquipment, setCurrentEquipment] = useState({});

    const statusChangeHandlerTable = (event: any,equipment:any) => {
        setCurrentEquipment(equipment);
        setEnteredStatusTable(event.target.value);
        showModalTable();
    };

    const [enteredstatus, setEnteredStatus] = useState('');

    const statusChangeHandler = (event: any) => {
        setEnteredStatus(event.target.value);
    };

    const [open, setOpen] = useState(true);

    const handleBackDropClose = () => {
      setOpen(false);
    };
    const classes = useStyles();
    
    useIonViewDidEnter(() => {

        axios.get(' https://dev.northroom.co.za/api/bizprop/equipment/all')
            .then(function (response) {
                // handle success            
                console.log(response.data);
                SetData(response.data);
                handleBackDropClose();
            })
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .then(function () {
                // always executed
            });
    });

    async function UpdateEquipment() {
        /* @ts-ignore */
        let tempclient = currentEquipment;
        /* @ts-ignore */
        tempclient.Status = enteredStatusTable;
        

        console.log(tempclient);
    
        try {
          axios({
            method: "post",
            url: "https://dev.northroom.co.za/api/bizprop/equipment/update",
            data: tempclient,
          })
            .then(function (response) {
              //handle success
              console.log(response);
            })
            .catch(function (response) {
              //handle error
              console.log(response);
            });
        } catch (error) {
          console.error(error.response.data);
        }
        
      }

    return (
        <IonPage>
            <Backdrop
                className={classes.backdrop}
                open={open}
                transitionDuration={1500}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <IonHeader>
                < Modal
                    
                    visible={isModalCreateVisibleTable}
                    onOk={handleTableCreateOk}
                    cancelButtonProps={{ style: { display: 'none' } }}
                >
                    <Space direction="vertical">
                        {/* @ts-ignore */}
                        <p>{enteredStatusTable} {currentEquipment.Name}</p>
                    </Space>
                </Modal>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonMenuButton />
                    </IonButtons>
                    <IonRow>
                        <PageHeader
                            className="site-page-header"
                            onBack={() => { props.history.goBack() }}
                            title="Equipment"
                        />
                    </IonRow>
                </IonToolbar>
            </IonHeader>

            <IonContent fullscreen >
                <IonHeader collapse="condense">
                    <IonToolbar>
                        <IonTitle size="large">{name}</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <Space direction="vertical">
                    <IonGrid>
                        <IonRow>
                            <IonCol size="11" style={{ paddingLeft: "2vw", paddingRight: "5vw" }}>
                                <IonCard>
                                    <IonCardHeader>
                                    <Link to={{ pathname: "/NewEquipment"}}  >
                                        <Button type="primary">
                                            Add Equipment
                                        </Button>
                                        </Link>

                                    </IonCardHeader>

                                    <IonCardContent>
                                        <div style={{ height: 400, width: '80vw', paddingRight: "7.5vw" }}>
                                            <DataGrid
                                                rows={data1}
                                                columns={columns}
                                                components={{
                                                    Toolbar: GridToolbar,
                                                }}
                                                sortModel={[
                                                    {
                                                        field: 'Name',
                                                        sort: 'asc' as GridSortDirection,
                                                    },
                                                ]}
                                            />
                                        </div>

                                    </IonCardContent>
                                </IonCard>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </Space>
            </IonContent>
        </IonPage>


    );
};

export default Equipment;